import React from 'react';

import { isFedRamp } from '@atlassian/atl-context';

import { SITE_ANALYTICS_PERMISSIONS_EVENTS_SOURCE } from '@confluence/confluence-analytics/entry-points/analyticsConstants';
import { SitePermissionsPageLoader } from '@confluence/confluence-analytics/entry-points/AnalyticsPagesLoaders';
import {
	SITE_ANALYTICS_PERMISSIONS_PLUGIN,
	FEDRAMP_SITE_ANALYTICS_PERMISSIONS_PLUGIN,
} from '@confluence/named-routes';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';
import { Redirection } from '@confluence/route-manager';
import { fg } from '@confluence/feature-gating';

export const SiteAnalyticsPermissionsRoute = () => {
	if (fg('confluence_frontend_analytics_permissions')) {
		return <SitePermissionsPageLoader />;
	}

	const url = isFedRamp()
		? FEDRAMP_SITE_ANALYTICS_PERMISSIONS_PLUGIN.toUrl()
		: SITE_ANALYTICS_PERMISSIONS_PLUGIN.toUrl();
	return <Redirection href={url} />;
};

SiteAnalyticsPermissionsRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: SITE_ANALYTICS_PERMISSIONS_EVENTS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
